import { getHumanReadableTime } from '@/services/timer/Timer'

import { useState, useEffect, useRef } from 'react'

export function HumanTime ({ date }) {
  const [text, setText] = useState(getHumanReadableTime(date))
  
  // TODO: We need to clean the timer after component is not rendered anymore
  // eslint-disable-next-line
  let timer = useRef()

  useEffect(() => {
    // eslint-disable-next-line
    timer = setInterval(() => {
      setText(getHumanReadableTime(date))
    }, 30000)

    return function cleanup () {
      clearInterval(timer)
    }
  }, [])

  return <span title={new Date(date).toLocaleString()}>{text}</span>
}
